(function () {
    $.ajaxSetup({
        headers: {
            'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
        },
    });
})();



// WEBPACK FOOTER //
// ./resources/scripts/portal/pages/taxes/taxes.js